<template>
  <div class="visit-work-order-table">
    <div class="visit-work-order-table__head">
      <div class="visit-work-order-table__head-cell">Услуга</div>
      <div class="visit-work-order-table__head-cell">Зубы</div>
      <div class="visit-work-order-table__head-cell">Кол-во</div>
      <div class="visit-work-order-table__head-cell">Цена</div>
      <div class="visit-work-order-table__head-cell">Цвет по шкале Vita</div>
    </div>
    <visit-work-order-table-row
      v-for="(item, index) in rows"
      v-bind:key="item.id || item.key"
      v-bind:price="item.price"
      v-bind:count="item.count"
      v-bind:service-name="item.serviceName"
      v-bind:teeth="item.teeth"
      v-bind:dental-parts="item.dentalParts"
      v-bind:vita="item.vita"
      v-bind:service-options="serviceOptions"
      v-on:delete="emitDelete(index, item)"
      v-on:input-price="onInputPrice(index, $event)"
      v-on:input-count="onInputCount(index, $event)"
      v-on:input-service-name="onInputServiceName(index, $event)"
      v-on:input-teeth="onInputTeeth(index, $event)"
      v-on:input-vita="onInputVita(index, $event)"
    />
  </div>
</template>
<script>
import VisitWorkOrderTableRow from '@/components/VisitWorkOrderTableRow.vue';
import focusMixin from '@/mixins/focusMixin';
import spreadDiscountMixin from '@/mixins/spreadDiscountMixin';

/**
 * @description Название события изменения услуги.
 * @type {string}
 */
const NAME_EVENT_CHANGE_ROW = 'change';

/**
 * @description Название события удаления услуги.
 * @type {string}
 */
const NAME_EVENT_DELETED_ROW = 'delete';

/**
 * @description Таблица услуг.
 * @type {any}
 */
export default {
  components: {
    VisitWorkOrderTableRow,
  },
  methods: {
    /**
     * @description Отправить событие изменения услуги.
     * @param {number} index Номер строки.
     * @param {any}    value Строка.
     */
    emitChange(index, value) {
      this.$emit(NAME_EVENT_CHANGE_ROW, index, value);
    },
    /**
     * @description Отправить событие удаление строки.
     * @param {number} index Номер строки.
     * @param {Object} value Строка.
     * @returns {void}
     */
    emitDelete(index, value) {
      this.$emit(NAME_EVENT_DELETED_ROW, index, value);
    },
    /**
     * @description Обработать ввод цены.
     * @param {number} index
     * @param {number} value
     * @returns {void}
     */
    onInputPrice(index, value) {
      const item = this.rows[index];
      item.price = value;
      this.emitChange(index, item);
    },
    /**
     * @description Обработать ввод количества.
     * @param {number} index
     * @param {number} value
     * @returns {void}
     */
    onInputCount(index, value) {
      const item = this.rows[index];
      item.count = value;
      this.emitChange(index, item);
    },
    /**
     * @description Обработать ввод названия услуги.
     * @param {number} index
     * @param {number} value
     * @returns {void}
     */
    onInputServiceName(index, value) {
      const item = this.rows[index];
      item.serviceName = value;
      this.emitChange(index, item);
    },
    /**
     * @description Обработать ввод зубов.
     * @param {number}                             index
     * @param {{teeth:number[],dentalParts:Array}} event
     * @returns {void}
     */
    onInputTeeth(index, { teeth, dentalParts }) {
      const item = this.rows[index];
      item.teeth = teeth;
      item.dentalParts = dentalParts;
      this.emitChange(index, item);
    },
    /**
     * @description Обработать ввод цвета по шкале Vita.
     * @param {number} index
     * @param {number} value
     * @returns {void}
     */
    onInputVita(index, value) {
      const item = this.rows[index];
      item.vita = value;
      this.emitChange(index, item);
    },
  },
  mixins: [focusMixin, spreadDiscountMixin],
  name: 'VisitWorkOrderTable',
  props: {
    /**
     * @description Строки таблицы.
     */
    rows: { required: true, type: Array },
    /**
     * @description Нарушения ограничений.
     * @type {Object}
     */
    violations: { default: () => {}, type: Object },
    /**
     * @description Варианты названий услуг с ценами.
     */
    serviceOptions: { required: true, type: Array },
  },
};
</script>
<style lang="scss">
.visit-work-order-table {
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;
  padding: 0 0 20px 0;
  &__head,
  &__row {
    display: grid;
    grid-template-columns:
      minmax(200px, 1fr) 100px 75px
      120px 150px 50px;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
  }
  &__row {
    &:hover {
      background: #eaeff3;
    }
  }
  &__head-cell {
    padding: 12px 8px;
  }
  &__cell {
    padding: 12px 8px;
    -moz-appearance: textfield;
    &:focus {
      border: 1px solid transparent !important;
      outline: 0;
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.edit {
      background-color: white;
      border: 1px solid #0076C3;
      border-radius: 4px;
      width: 90%;
      padding: 12px 8px !important;
      margin: 0 !important;
      height: 28px;
      position: relative;
      &:focus {
        color: #212529;
        border: 1px solid #0489e0 !important;
        outline: 0;
      }
    }
  }
  &__select {
    .v-input__slot {
      border: 1px solid #0076C3;
    }
    .menuable__content__active {
      min-width: 150px !important;
    }
    &.v-text-field.v-text-field--solo .v-input__control {
      min-height: 28px !important;
    }
  }
  &__combobox {
    &.v-text-field--outlined>.v-input__control>.v-input__slot {
      min-height: 28px !important;
    }
    &.v-text-field--outlined fieldset {
      border: 1px solid transparent;
    }
    &.v-text-field--outlined.v-input--has-state fieldset,
    &.v-text-field--outlined.v-input--is-focused fieldset {
      border: 1px solid transparent;
    }
    .v-input__append-inner {
      margin-top: 4px;
    }
  }
  &__icon {
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
}

@media screen and (max-width: 1560px) {
  .visit-work-order-table {
    overflow-x: scroll;
    &__head,
    &__row {
      width: 100%;
      min-width: 1300px;
    }
  }
}

/* Убираем стрелки в Chrome, Safari, Edge и других WebKit-браузерах */
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
